export default "__VITE_ASSET__CgbtJ4sC__"